import { render, staticRenderFns } from "./SkillsAreas.vue?vue&type=template&id=07ba6be4&scoped=true&"
import script from "./SkillsAreas.vue?vue&type=script&lang=js&"
export * from "./SkillsAreas.vue?vue&type=script&lang=js&"
import style0 from "./SkillsAreas.vue?vue&type=style&index=0&id=07ba6be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ba6be4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCol,VContainer,VIcon,VResponsive,VRow,VSheet})
